import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNdd65 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzNdd65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NDD_65: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_NDD_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/subscriptions/SubscriptionNdd65'
      ).then((m) => ({
        default: m.SubscriptionsNdd65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/subscriptions/SubscriptionNdd65'
      ),
  },
  [PageId.CHAT_UPSELL_NDD_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NDD_65]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzNdd65.DOWNLOAD_NDD_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNdd65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
